class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.submenuItems = this.querySelectorAll('.header__submenu-list .list-menu__item');

    for (var i = 0; i < this.submenuItems.length; i++) {
      this.submenuItems[i].addEventListener('mouseover', this.bindHover.bind(this));
    }
  }

  bindHover(event) {
    const hoveredIndex = event.target.getAttribute('data-nav-image-control');
    const hoveredImage = this.querySelector(`.header__submenu-image[data-nav-image="${hoveredIndex}"]`);

    // loop over all images and remove class
    this.querySelectorAll('.header__submenu-image').forEach((image) => {
      image.classList.remove('header__submenu-image--active');
    });

    // add class to hovered image
    hoveredImage.classList.add('header__submenu-image--active');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }
}

customElements.define('header-menu', HeaderMenu);
